import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_mentor_profile_data_action,
  update_user_meta_data_action,
} from "../../../redux/_actions";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
function MentorProfile(props) {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState({});
  const [loadingUploadResume, setLoadingUploadResume] = useState(false);
  const [userPrimarySkills, setUserPrimarySkills] = useState([]);

  //get data from redux
  const { mentorProfileData } = useSelector(
    (state) => state.get_mentor_profile_data_reducer
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (mentorProfileData?.data) {
      setUserData(mentorProfileData?.data);
    }
  }, [mentorProfileData]);

  useEffect(() => {
    if (mentorProfileData?.data) {
      getUserPrimarySkills(mentorProfileData?.data);
    }
  }, [mentorProfileData]);

  const callApi = async () => {
    setLoading(true);
    await dispatch(get_mentor_profile_data_action());
    setLoading(false);
  };
  const getUserPrimarySkills = (data) => {
    let skills = data && data?.skills;

    let results = skills && skills.filter((item) => item?.is_primary === true);

    if (results.length > 0) setUserPrimarySkills(results);
    else setUserPrimarySkills(skills);
  };

  const onEditProfile = () => {
    navigate("/edit-mentor-profile");
  };

  const onUploadResume = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);

    if (file) {
      if (file && file.type === "application/pdf") {
        setLoadingUploadResume(true);
        await dispatch(update_user_meta_data_action(data));
        await dispatch(get_mentor_profile_data_action());
        setLoadingUploadResume(false);
      } else {
        showWarningMessage("Please select a PDF file.");
      }
    }
  };
  return {
    onEditProfile,
    loading,
    userData,
    userPrimarySkills,
    onUploadResume,
    loadingUploadResume,
  };
}
export default MentorProfile;
